import clsx from 'clsx';
import { calcExpireDate } from 'common/method/helper';
import { FC, useState, useRef, useEffect } from 'react';
import { PatternFormat } from 'react-number-format';
import Timer from '../Timer';
import { UseIsMobile } from 'common/hooks/UseIsMobile';
import { useTranslation } from 'react-i18next';

type InputPinType = {
  sendCodeAgain: () => void;
  value: string;
  onChange: (val: string) => void;
  expireDate: any;
};

const InputPin: FC<InputPinType> = ({
  sendCodeAgain,
  value,
  onChange,
  expireDate,
}) => {
  const [inTime, setInTime] = useState<boolean>(true);
  const [isFocus, setIsFocus] = useState(true);
  const { minutes, seconds } = calcExpireDate(expireDate)
  const isMobile = UseIsMobile();

  let refInputPin = useRef<any>();
  let refAc = useRef<AbortController | undefined>();

  const { t } = useTranslation()

  const webOtpStart = () => {
    try {
      if ('OTPCredential' in window && isMobile) {
        const input: any = document.querySelector('input[autocomplete="one-time-code"]');
        if (!input) return;

        refAc.current = new AbortController();
        navigator.credentials.get({
          otp: { transport: ['sms'] },
          signal: refAc.current.signal
        }).then((otp: any) => {
          onChange(otp.code);
        }).catch();
      }
    } catch {
      console.log("wrong when use OTPCredential")
    }
  }

  const webOtpAbort = () => {
    refAc.current && refAc.current.abort();
  }


  useEffect(() => {
    const clear = setTimeout(() => {
      webOtpStart()
      clearTimeout(clear)
    }, 2000);

    return () => {
      webOtpAbort()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const timeIsDown = () => {
    setInTime(false);
  };

  const clickSendCode = () => {
    webOtpAbort()
    sendCodeAgain();
    setInTime(true);
    const clear = setTimeout(() => {
      webOtpStart()
      clearTimeout(clear)
    }, 2000);
  };

  const handleClickRetryOtp = () => {
    if (inTime) {
      return null;
    } else {
      clickSendCode();
      onChange('');
      refInputPin?.current.focus();
      setIsFocus(true);
    }
  };

  return (
    <div>
      <div className="flex flex-row-reverse items-center">
        <div
          onClick={handleClickRetryOtp}
          data-actived={isFocus}
          className={clsx(
            'actived:border-L-info-100 inset-y-0 left-0 border border-r-0  h-[42px] leading-[42px] px-4 border-L-gray-100 rounded-l-2xl bg-L-basic whitespace-nowrap inline-block text-2xl text-L-primary-50',
            {
              'border-L-info-100': isFocus,
            }
          )}
        >
          {inTime ? (
            <Timer
              initialMinute={minutes}
              initialSeconds={seconds}
              timeIsDown={timeIsDown}
            />
          ) : (
            t(`FormSide.ResendCode`)
          )}
        </div>
        <PatternFormat
          className="border grow text-center  ltr border-L-gray-100 outline-none w-full h-[42px] rounded-r-2xl rounded-l-none px-4 placeholder:text-xs placeholder:text-L-gray-350 bg-L-basic focus:border-L-info-100"
          format="# # # # # #"
          allowEmptyFormatting
          mask="_"
          onFocus={() => setIsFocus(true)}
          onBlur={() => setIsFocus(false)}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          getInputRef={refInputPin}
          autoFocus
          autoComplete='one-time-code'
          type='text'
          inputMode='numeric'
        />
      </div>
      <span className="text-L-gray-200 text-xl mt-2 inline-block">
        {/* (مدت اعتبار کد یکبار مصرف ارسال شده {(minutes ? minutes : "1") + (seconds ? "." + seconds : "")} دقیقه است) */}
        (مدت اعتبار کد یکبار مصرف ارسال شده 2 دقیقه است)
      </span>
    </div>
  );
};

export default InputPin;
